import React from 'react';

import s from './Video.scss';
import { Container } from 'components/container/Container';
import { Row } from 'components/row/Row';

interface IProps {
  src?: string;
  caption?: React.ReactElement<any>;
  credits?: React.ReactElement<any>;
  offset?: boolean;
}

export const Video = ({ src, caption, credits, offset }: IProps) => {
  return (
    <Container>
      <Row>
        <div className={s('video', { offset })}>
          <div className={s.video__wrapper}>
            <iframe
              width="1290"
              height="726"
              seamless
              className={s.video__iframe}
              frameBorder="0"
              allowFullScreen
              src={src}
            />
          </div>
          <div className={s.video__caption}>
            {caption} – {credits}
          </div>
        </div>
      </Row>
    </Container>
  );
};
